// Common English nouns with known brand-domain collisions. Used by the
// brand-collision fallback signal in hybrid mode. Keep entries to single
// lowercase tokens; multi-word phrases are evaluated token-by-token.
export const COMMON_NOUNS: ReadonlySet<string> = new Set([
  'next',
  'best',
  'stars',
  'lake',
  'square',
  'list',
  'apple',
  'core',
  'target',
  'harvest',
  'gear',
  'prime',
  'ghost',
  'mint',
  'atlas',
  'summit',
  'beacon',
  'anchor',
  'fire',
  'ember',
  'forge',
  'pulse',
  'river',
  'ridge',
  'pine',
  'oak',
  'elm',
  'branch',
  'root',
  'leaf',
  'spark',
  'vault',
  'haven',
  'nest',
  'hive',
  'canvas',
  'palette',
  'prism',
  'crystal',
  'diamond',
  'pearl',
  'coral',
  'amber',
  'onyx',
  'jade',
  'mango',
  'peach',
  'cherry',
  'olive',
  'berry',
  'plum',
]);
